fx.ns("repositories", class CoversRepository extends fx.ModelArray {

	constructor(data)
	{
		super(data);

        this._cache = {};
	}

    getCover(cover)
    {
        return this.find({option_id : this.getOptionId(cover)});
    }

    getFormatId(format)
    {
        let formatid;
        switch(format)
        {
            case models.ProductBook.SQUARE : 
                formatid = 2;
                break;
            case models.ProductBook.LANDSCAPE : 
                formatid = 11;
                break;
            case models.ProductBook.PORTRAIT : 
                formatid = 10;
                break;
        }
        return formatid;
    }

    getOptionId(cover)
    {
        let optionid;
        switch(cover.toLowerCase())
        {
            case models.ProductBook.SPIRAL : 
                optionid = 3;
                break;
            case models.ProductBook.BIND : 
                optionid = 6;
                break;
            case models.ProductBook.SOFT : 
                optionid = 1;
                break;
            case models.ProductBook.HARD : 
                optionid = 2;
                break;
            case models.ProductBook.LAYFLAT : 
                optionid = 9;
                break;
        }
        return optionid;
    }

    getOptionCode(optionid)
    {
        let code;
        switch(optionid)
        {
            case "3":
                code = models.ProductBook.SPIRAL ;
                break;
            case "6": 
                code = models.ProductBook.BIND ;
                break;
            case "1": 
                code = models.ProductBook.SOFT;
                break;
            case "2": 
                code = models.ProductBook.HARD;
                break;
            case "9": 
                code = models.ProductBook.LAYFLAT;
                break;
        }
        return code;
    }

    load()
    {
        if (this._coversloaded)
         this.event("cover-option-loaded");
        else
            this.post( "/app/creationoptions", { product_type_id : models.ProductType.BOOK}, 
                                        this._loaded);
        
    }

    _loaded(data)
    {
        if (data.error)
        {
            //this.event("server-error", data);
            this.event("load-covers-error", data);
            return;
        }

        this.init( data );

        this._coversloaded = true;

        this.event("cover-option-loaded");
    }

    getPriceOption(option)
    {
        let coverChoice = this.find({"option_id" : this.getOptionId(option)});

        return (coverChoice ? (coverChoice.price_base * fx.get("lang").tax) : 0).toFixed(2);
    }

});